import styled from 'styled-components'
import { CartButton } from '@/features/shop/components/CartButton'
import { Row } from '@shipt/design-system-layouts'
import { StoreSelector } from '@/features/shared/components/Autocomplete/StoreSelector'
import { useQueryActiveOrders } from '@/features/shop/services/Orders/queries'
import { OrderIcon } from '@shipt/design-system-icons'
import dynamic from 'next/dynamic'
import { routes } from '@shared/constants/routes'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { NextLink } from '@/features/shared/elements/Link'
import { useIsGuestUser, useIsVisitorOrZipOnly } from '@/features/account/services/User/hooks'
import { IconButton } from '@shipt/design-system-buttons'
import { WithTooltip } from '@/features/shared/elements/Tooltip/WithTooltip'
import { AccountCreationButtons } from '@/features/shared/components/GuestUser/AccountCreationButtons'

const UpcomingOrdersButton = dynamic(
  async () => (await import('./UpcomingOrdersButton')).UpcomingOrdersButton,
  { loading: () => <OrderButton /> },
)

export const RightMenuItems = ({ isPastScrollThreshold }: { isPastScrollThreshold?: boolean }) => {
  const { data: activeOrders } = useQueryActiveOrders()
  const isGuestAccount = useIsGuestUser()
  const isVisitorOrZipOnly = useIsVisitorOrZipOnly()

  return (
    <>
      <Row align="center" spacing="xl" display={{ base: 'flex', sm: 'none' }}>
        {!isVisitorOrZipOnly && <CartButton />}
      </Row>
      <Row
        spacing={{
          base: 'sm',
          lg: 'lg',
        }}
        display={{ base: 'none', sm: 'flex' }}
        align="center"
      >
        <StoreSelector />
        {!isGuestAccount && (
          <OrdersContainer isPastScrollThreshold={isPastScrollThreshold}>
            {activeOrders && activeOrders.length > 0 ? (
              <UpcomingOrdersButton activeOrders={activeOrders} />
            ) : (
              <OrderButton />
            )}
          </OrdersContainer>
        )}
        {!isVisitorOrZipOnly && <CartButton />}
        {!!isGuestAccount && <AccountCreationButtons isHeader />}
      </Row>
    </>
  )
}

export const OrderButton = ({ holidayGHP }: { holidayGHP?: boolean }) => {
  return (
    <WithTooltip message="Orders" placement="bottom">
      <IconButton
        icon={OrderIcon}
        variant={holidayGHP ? 'primary' : 'tertiary'}
        surface={holidayGHP ? 'inverse' : undefined}
        size="md"
        forwardedAs={NextLink}
        href={routes.ORDER_LIST.url}
        aria-label="view orders history"
        onClick={() => {
          trackElementClicked({
            type: 'button',
            content: 'orders_link',
            display_format: 'horizontal_list',
          })
        }}
      />
    </WithTooltip>
  )
}

const OrdersContainer = styled.div<{ isPastScrollThreshold?: boolean }>`
  opacity: ${({ isPastScrollThreshold }) => (isPastScrollThreshold ? 0 : 1)};
  transition: opacity 0.6s ${({ isPastScrollThreshold }) => (isPastScrollThreshold ? '0.1s' : '')}
    ease;
`
